import axiosInstance from "../../interceptor/axiosInstance";
import ApiRoutes from "../../routes/routeConstants/apiRoutes";
import { deserialize } from "serializr";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";
import { Tag } from "../../models/Tag/tag.model";
import { UserRoleEnum } from "../../enums/userRole.enum";

export default class TagService {
    static fetchAdminTags(
      userRole: UserRoleEnum,
      onSuccess: Function,
      onError: Function,
      onFinal: () => void
    ) {
        axiosInstance
          .get(userRole === UserRoleEnum.ADMIN ? ApiRoutes.ADMIN_TAGS : ApiRoutes.TAGS)
          .then((response) => {
            const tags = deserialize(Tag, response.data);
            onSuccess(tags);
          })
          .catch((error) => {
            onError();
          })
          .finally(() => {
            onFinal();
          });
    }

    static createCustomTags(
        payload: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        axiosInstance
            .post(ApiRoutes.ADMIN_TAGS, payload)
            .then((response) => {
                const tag = deserialize(Tag, response.data);
                onSuccess(tag);
            })
            .catch((error) => {
                onError(error);
            })
            .finally(() => {
                onFinal();
            });
    }

    static updateCustomTags(
        tagId: number,
        payload: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        axiosInstance
            .put(
                `${ApiRoutes.ADMIN_TAGS}/${tagId}`,
                payload
            )
            .then((response) => {
                const tag = deserialize(Tag, response.data);
                onSuccess(tag);
            })
            .catch((error) => {
                onError(error);
            })
            .finally(() => {
                onFinal();
            });
    }


    static updateAdminTags(
        caseId: number,
        userRole: UserRoleEnum,
        tagIds: (number | undefined)[],
        onSuccess: Function,
        onError: Function,
        onFinal: () => void,
        options?: { reason?: string }
    ) {
      let apiRoutes;

      if (userRole === UserRoleEnum.ADMIN) {
        apiRoutes = ApiRoutes.UPDATE_ADMIN_TAGS;
      } else if (userRole === UserRoleEnum.DOCTOR) {
        apiRoutes = ApiRoutes.UPDATE_DOCTOR_TAGS;
      } else {
        apiRoutes = ApiRoutes.UPDATE_SCAN_CENTER_TAGS;
      }
      const body: Record<string, unknown> = { tag_ids: tagIds };
      if ((options?.reason ?? "").trim() !== "") {
        body.interesting_keyword = (options?.reason as string).trim();
      }
      axiosInstance
        .put(apiRoutes.replace(':caseDetailId', caseId.toString()), body)
        .then((response) => {
          Notification({
              message: "Tag updated",
              type: NotificationTypes.SUCCESS,
            });
          const tags = deserialize(Tag, response.data);
          onSuccess(tags);
        })
        .catch((error) => {
          onError();
        })
        .finally(() => {
          onFinal();
        });
    }
}
